export const RATING_ERROR = 'RATING_ERROR' as const

export const ratingErrorAction = (value: string) => ({
  type: RATING_ERROR,
  value,
})

export const CLEAR_ERROR = 'CLEAR_ERROR' as const

export const ratingClearErrorAction = () => ({ type: CLEAR_ERROR })
